import { render, staticRenderFns } from "./section-view.vue?vue&type=template&id=0f979d1e&"
import script from "./section-view.vue?vue&type=script&lang=js&"
export * from "./section-view.vue?vue&type=script&lang=js&"
import style0 from "./section-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports